import Router from '../router'
import axios from 'axios'
import qs from 'qs'
import { installMockInterceptor } from '../utils/mockInterceptor'

axios.defaults.withCredentials = true;//跨域
// axios.defaults.baseURL = 'http://localhost:9000/threePieceSet/';  //测试
// axios.defaults.baseURL = 'http://120.76.42.53:9000/threePieceSet/';  //测试
axios.defaults.baseURL = 'https://okaka.bglemon.com/threePieceSet/';  //测试

// WebSocket 配置
export const wsConfig = {
    serverUrl: 'wss://okaka.bglemon.com/threePieceSet/device/wake'
}

axios.defaults.headers = {
    // "Content-Type": "application/x-www-form-urlencoded"
    "Content-Type": "application/x-www-form-urlencoded"
}
axios.defaults.transformRequest = function(data){
    data = qs.stringify(data);
    return data;
}

// 安装模拟数据拦截器
installMockInterceptor(axios);

axios.interceptors.request.use(
    config=>{
        const userInfo = localStorage.getItem('userInfo');
        if (userInfo) {
            const { token } = JSON.parse(userInfo);
            if (token) {
                config.headers['Authorization'] = token;
            }
        }
        return config;
    },
    error=>{
        return Promise.reject(error);
    }
);

export async function getDevNo() {
    const res = await axios.get('user/getDevNo')
    return res.data.data
}

export {axios}
